"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_APP_DEF_ID = void 0;
exports.VIDEO_APP_DEF_ID = '14409595-f076-4753-8303-9a86f9f71469';
//# sourceMappingURL=app-def-id.js.map